import gql from 'fraql'
const ordersMeta = {
  TYPES_DISCOUNT: gql`
    query {
      getTypesDiscount {
        nodes {
          id
          name
          defaultValue
          logicType
          active
          keyword
          comment
        }
      }
    }
  `,
  LIST_PROMOCODES: gql`
    query {
      getActivePromocodes {
        nodes {
          id
          promocode
          description
          active
          idBrand
          result
          rules
          onlyMobile
        }
      }
    }
  `
}

export default ordersMeta


// WEBPACK FOOTER //
// ./src/graphql/ordersMeta.js